import React from 'react'
import { Link } from "react-router-dom";
import "../../styles/policy/privacy-p.css"
function PrivacyPolicy() {
    return (
        <>
         <section className="privacy" >
        <div className="lamar-container">
          <div className="path">
            <Link to="/">
              <i class="fas fa-home"></i>
            </Link>
            <i class="fas fa-angle-right"></i> <span>Delivery Policy</span>
          </div>
        </div>
        <div className="lamar-container">
            <p>This privacy and policy describe how we collect the information you provide on our Website, and how we use the information, some of the security steps taken to protect the information, and the choices you must review, revise and/or restrict our usage of this information. This Policy is part of the Terms & Conditions of Use that govern the Website and is binding on all Website users. All credit/debit cards details and personally identifiable information will NOT be stored, sold, shared, rented or leased to any third parties. Security capabilities and policy for transmission of payment card details has to be mentioned on the website.</p>
            <ol>
                <li>Why Your Personal Information</li>
                <ul>
                    <li>We ask you to share your personal data with us for purposes.</li>
                    <li>Activating or registering certain products or enhancing functionality.</li>
                    <li>Buying lamar products online.</li>
                    <li>Receiving information about Motahajiba products and services.</li>
                    <li>Participating in Motahajiba online communities, including our social media channels/pages and blogs.</li>
                    <li>Helping us to improve products and services, and allowing Motahajiba to keep you informed of, or involve you in testing of, new products and services.</li>
                    <li>Resolving consumer and/or product issues.</li>
                    <li>Receiving personalized messages, special offers and advertisements that are relevant to your personal interests, based on the information you have shared with us and on the information, we have collected through cookies or similar techniques regarding your use of the Motahajiba websites/social media.</li>
                </ul>

                <p>We generally process your personal data only for those purposes that we have communicated with you. If we use it for other (closely related) purposes, additional data protection measures will be implemented if required by law. The information includes Email, Name, Company Name, Street Address, Post Code, City, Country, Telephone Number, and So on.</p>
          
                <li> What is the Use of Your Information.</li>
           
            <p>To Help you to make this Site easier to use by not having to enter information more than once. Help you quickly find information, products, and services. Help us to create content on this Site that is most relevant to you. Alert you to new information, products, and services that we offer. You can share your personal data with <span>lamar</span> in several ways, including, but not limited to. Registering as a member of  <span> lamar</span>. Communicating with Customer Care representatives by email or phone or in writing. Ordering a product.</p>
            
                <li>Participating in a promotion, game or competition.</li>
         
            <p>Participating in a social media activity related to a Motahajiba Asking to receive messages on your mobile phone/device. Subscribing to a newsletter. Voluntarily participating in product testing or surveys. Social sign-on (using your Facebook or LinkedIn credentials, for example, to create an account or log on).Cookies placed on your computer or mobile device when you visit our websites.</p>
           
                <li>
                USE AND DISCLOSURE OF INFORMATION
                </li>
          
            <p>
            Except as otherwise stated below, we do not sell, trade or rent your personally identifiable information collected on the site to others. The information collected by our site is used to process orders, to keep you informed about your order status, to notify you of products or special offers that may be of interest to you, and for statistical purposes for improving our site. We will disclose your Delivery information to third parties for order tracking purposes or process your check or money order, as appropriate, fill your order, improve the functionality of our site, perform statistical and data analyses deliver your order and deliver promotional emails to you from us. For example, we must release your mailing address information to the delivery service to deliver products that you ordered. All credit/debit cards’ details or personally identifiable information will NOT be stored, sold, shared, rented or leased to any third parties
            </p>
           
                <li>
                SECURITY.
                </li>
           
            <p>
            <span> lamar</span> takes appropriate steps to ensure data privacy and security including through various hardware and software methodologies. However, <span> lamar</span> cannot guarantee the security of any information that is disclosed online.
            </p>
          
                <li>
                MINORS.
                </li>
           
            <p>
                <span> lamar</span>  does not knowingly collect personal information from minors under the age of 18. Minors are not permitted to use the <span> lamar</span>  website or services, and <span> lamar</span>  requests that minors under the age of 18 not submit any personal information to the website. Since information regarding minors under the age of 18 is not collected, <span> lamar</span>  does not knowingly distribute personal information regarding minors under the age of 18.
            </p>
            
                <li>
                MODIFICATIONS OF THE PRIVACY POLICY LAMAR
                </li>
         
            <p>
            The Website Policies and Terms & Conditions would be changed or updated occasionally to meet the requirements and standards. Therefore the Customers’ are encouraged to frequently visit these sections in order to be updated about the changes on the website. Modifications will be effective on the day they are posted”.
            </p>
          
                <li>
                Social Media
                </li>
         
            <p>
            When you participate in various social media forums like Facebook, Twitter, Yammer, Pinterest, Instagram etc., you should be familiar with and understand the tools provided by those sites that allow you to make choices about how you share the personal data in your social media profile(s).
            </p>
            </ol>
            
               
        </div>
        </section>
            
        </>
    )
}

export default PrivacyPolicy
